import VueRouter from 'vue-router';

import Error404 from '../pages/errors/Error404';

import Login from '../pages/Login';
import FindPhotos from '../pages/FindPhotos';
import Register from '../pages/Register';
import PasswordReset from '../pages/PasswordReset';
import ForgotPassword from '../pages/ForgotPassword';

import Order from '../pages/Order';
import Receipt from '../pages/Receipt';
import MyAccount from '../pages/MyAccount';

const routes = [
    {
        path: '/',
        name: 'home',
        redirect: {
            name: 'order'
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            title: route => {
                return 'Sign In'
            }
        }
    },

    //Guid Login
    {
        path: '/findphotos',
        name: 'findphotos',
        component: FindPhotos,
        meta: {
            title: route => {
                return 'Finding Photos'
            }
        }
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: {
            title: route => {
                return 'Register'
            }
        }
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: ForgotPassword,
        meta: {
            title: route => {
                return 'Forgot Password'
            }
        }
    },
    {
        path: '/password/reset/:token',
        name: 'reset-password',
        component: PasswordReset,
        meta: {
            title: route => {
                return 'Reset Password'
            }
        }
    },
    {
        path: '/order/receipt/:cart_id?',
        name: 'order-receipt',
        component: Receipt,
        meta: {
            auth: true,
            title: route => {
                return 'Order Receipt'
            }
        }
    },
    {
        path: '/order/:step?/:package?',
        name: 'order',
        component: Order,
        meta: {
            auth: true,
            title: route => {
                return 'Order Photos'
            }
        }
    },
    {
        path: '/account',
        name: 'account',
        component: MyAccount,
        meta: {
            auth: true,
            title: route => {
                return 'My Account'
            }
        }
    },
    {
        path: '*',
        name: '404',
        component: Error404,
        meta: {
            title: route => {
                return '404 Page Not Found'
            }
        }
    }
];

const router = new VueRouter({
    history: true,
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 }
        }
    }
});

router.beforeEach(async (to, from, next) => {
    await auditRecordRoute(to);
    next();
});

async function auditRecordRoute(to) {
    try {
        await axios.post('audit/route', {
            url: to.fullPath,
            query: {
                ...to.query
            }
        });
    } catch (error) {
        console.error(error);
    }
}

export default router;
